<div class="row">
  <div class="col-md-6">
    <div class="container-card">
      <h4 class="f-16 text__grey-800 mb-3">Dishes</h4>
      <ng-container *ngFor="let item of orderDetails.dishes | keyvalue">
        <div class="mb-3">
          <app-base-card [internalPadding]="false">
            <section class="border-bottom p-3">
              <p class="mb-0 fw-600 f-14 lh-20">
                {{ item.key }}
              </p>
            </section>

            <section class="p-3">
              <ng-container *ngFor="let meal of item?.value; last as isLast">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <div class="d-flex align-items-center">
                    <section class="gap-8 d-flex align-items-center">
                      <div class="food__img">
                        <img
                          *ngIf="isImageValid(meal.imageUrl)"
                          [src]="meal?.imageUrl"
                          [alt]="meal.name"
                        />
                        <img
                          *ngIf="!isImageValid(meal.imageUrl)"
                          src="/assets/images/no-food-img.svg"
                          [alt]="meal.name"
                        />
                      </div>
                      <p class="mb-0 lh-24 fw-400 text__grey-500">
                        &#215;{{ meal?.quantity }}
                      </p>
                      <p
                        class="mb-0 lh-24 fw-400 text__grey-800 text-capitalize"
                      >
                        {{ meal?.name }}
                      </p>
                    </section>
                  </div>
                  <div>
                    <p class="text__grey-600 lh-20 mb-0 f-14 fw-600">
                      {{ meal.totalPrice | currency : '₦' }}
                    </p>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <p
                    class="mb-0 f-14 lh-20 text-capitalize fw-400 text__grey-700"
                  >
                    Takeaway price
                  </p>
                  <p class="text__grey-600 lh-20 mb-0 f-14 fw-600">
                    {{ meal.takeawayPrice | currency : '₦' }}
                  </p>
                </div>

                <section class="addons mt-3" *ngIf="meal?.addons?.length">
                  <div class="">
                    <h6 class="text__grey-500 f-13 lh-16 fw-400">ADD-ONS</h6>
                    <ng-container *ngFor="let addOn of meal.addons">
                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <p
                          class="mb-0 f-14 lh-20 text-capitalize fw-400 text__grey-700"
                        >
                          {{ addOn.name }}
                        </p>
                        <p class="text__grey-600 lh-20 mb-0 f-14 fw-600">
                          {{ addOn.price | currency : '₦' }}
                        </p>
                      </div>
                    </ng-container>
                  </div>
                </section>
              </ng-container>
            </section>
          </app-base-card>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="col-md-6 mt-3 mt-md-0">
    <div class="container-card-2">
      <h4 class="f-16 text__grey-800 mb-3">Order details</h4>
      <app-base-card [internalPadding]="false">
        <div class="p-3">
          <!-- Reservation Time Display (when inTransit is true) -->
          <div
            *ngIf="
              orderDetails?.inTransit &&
              orderDetails?.reservationStartTime &&
              orderDetails?.reservationEndTime
            "
            class="mb-3 p-2"
            style="
              background-color: #f0f8ff;
              border-left: 4px solid #007bff;
              border-radius: 4px;
            "
          >
            <div class="d-flex align-items-center justify-content-between mb-2">
              <p class="mb-0 f-14 fw-600" style="color: #007bff">
                Reservation Time
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-1">
              <p class="mb-0 f-12 text__grey-500">Start:</p>
              <p class="mb-0 f-14 fw-500" style="color: #007bff">
                {{ orderDetails.reservationStartTime | date : 'short' }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <p class="mb-0 f-12 text__grey-500">End:</p>
              <p class="mb-0 f-14 fw-500" style="color: #007bff">
                {{ orderDetails.reservationEndTime | date : 'short' }}
              </p>
            </div>

            <!-- Countdown Timer -->
            <div
              *ngIf="showCountdown"
              class="mt-2 p-2 text-center"
              [ngStyle]="{
                'background-color':
                  countdownText === 'EXPIRED' ? '#ffebee' : '#fff3cd',
                color: countdownText === 'EXPIRED' ? '#d32f2f' : '#856404',
                'border-radius': '4px',
                border:
                  '1px solid ' +
                  (countdownText === 'EXPIRED' ? '#f5c6cb' : '#ffeaa7')
              }"
            >
              <p class="mb-0 f-12 fw-600">
                {{
                  countdownText === 'EXPIRED'
                    ? 'RESERVATION EXPIRED'
                    : 'TIME REMAINING'
                }}
              </p>
              <p class="mb-0 f-16 fw-700">{{ countdownText }}</p>
            </div>
          </div>

          <!-- Existing order details -->
          <div class="d-flex align-items-center justify-content-between mb-2">
            <p class="mb-0 f-14 text__grey-500">Order status</p>
            <span
              class="badge"
              [ngClass]="['order-badge-' + orderDetails.status.toLowerCase()]"
            >
              {{ orderDetails.status }}
            </span>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-2">
            <p class="mb-0 f-14 text__grey-500">Order destination</p>
            <p
              *ngIf="orderDetails?.orderType === 'DINE_IN'"
              class="mb-0 f-16 fw-600 lh-24"
            >
              {{ orderDetails.table }}
            </p>
            <p
              *ngIf="
                orderDetails?.orderType === 'DELIVERY' &&
                orderDetails?.customerDetails
              "
              class="mb-0 f-16 fw-600 lh-24"
            >
              {{ createAddress(orderDetails.customerDetails.address) }}
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-2">
            <p class="mb-0 f-14 text__grey-500">Order ID</p>
            <p class="mb-0 f-16 fw-600 lh-24">#{{ orderDetails.orderId }}</p>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <p class="mb-0 f-14 text__grey-500">Order code</p>
            <p class="mb-0 f-16 fw-600 lh-24">#{{ orderDetails.code }}</p>
          </div>
        </div>
      </app-base-card>

      <div class="mt-3" *ngIf="orderDetails.specialRequest">
        <h4 class="f-16 text__grey-800 mb-2">Customer notes</h4>
        <app-base-card [internalPadding]="false">
          <div class="p-3">
            <p class="mb-0 f-14 text__grey-700 fw-600 lh-24">
              {{ orderDetails.specialRequest }}
            </p>
          </div>
        </app-base-card>
      </div>
      <!-- <h4 class="f-16 text__grey-800 mb-3">Customer details</h4> -->

      <div
        class="bottom-card card border-0 w-100"
        *ngIf="orderDetails.status !== 'READY'"
      >
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <!-- <button class="btn btn__reject-order" (click)="openDrawer()">
              Reject order
            </button> -->
            <app-base-button
              *ngIf="['NEW', 'ACCEPTED'].includes(orderDetails.status)"
              (click)="handleOrderStatusUpdate.emit(orderDetails)"
              [label]="
                orderDetails.status === 'NEW'
                  ? 'Accept order'
                  : 'Mark order as ready'
              "
              [colorClasses]="
                'custom__btn custom__btn-brand custom-btn-lg w-unset fw-600 lh-24 p-12-20'
              "
            ></app-base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
